export const criticalMessages = [
  'login_msg.default.failure',
  'login_msg.reset.failure.access_expired',
  'login_msg.reset.failure.reused_link',
  'login_msg.unblock.failure.access_expired',
  'login_msg.unblock.failure.reused_link',
  'error.signup_again',
] as const;
export type CriticalMessage = (typeof criticalMessages)[number];

export const positiveMessages = [
  'login_msg.activate.success',
  'login_msg.default.success',
  'login_msg.register.success',
  'login_msg.reset.success',
  'login_msg.unblock.success',
  'login_msg.verify.success',
] as const;
export type PositiveMessage = (typeof positiveMessages)[number];

export const errorMessages = [
  'error.expired_password',
  'error.user_is_blocked',
  'error.no_mfa_factors',
  'error.expiration_time_claim',
  'error.no_query_params',
  'error.consent_required',
  'error.invalid_state',
  'error.social_provider_email_required',
  'error.apple_signin_account_required',
  'error.email_verification_required',
  'error.force_email_verififcation_rule_generic_error',
  'error.impersonation_failed_unauthorized_seek_network_required',
  'error.impersonation_failed_unauthorized',
  'error.impersonation_failed_selfImpersonation',
  'error.impersonation_failed_testUser',
  'error.impersonation_failed_userNotFound',
  'error.login_not_allowed',
  'error.default',
] as const;
export type ErrorMessage = (typeof errorMessages)[number];

// These are to be used for error codes to be shown to internal users e.g., errors for impersonation etc.
export const errorWithSubCodes = [] as const;
export type ErrorSubCodeMessage = (typeof errorWithSubCodes)[number];

export type Message =
  | CriticalMessage
  | PositiveMessage
  | ErrorMessage
  | ErrorSubCodeMessage;

export interface ErrorObj {
  errorCode: string;
  errorSubCode?: string;
}

// List of error messages not to be shown on login form
export const escapedLoginFormMessages = ['error.expired_password'];
